export const NONE = 'NO_ACCESS';
const NONE_LEVEL = 1;

export const READ = 'READ';
export const VIEW = READ;
const READ_LEVEL = 2;

export const CLIENT = 'CLIENT';
const CLIENT_LEVEL = 3;

export const USER = 'USER';
const USER_LEVEL = 4;

export const OWNER = 'OWNER';
const OWNER_LEVEL = 5;

const defaultRole = NONE;

const roleToLevel = {
    [NONE]: NONE_LEVEL,
    [READ]: READ_LEVEL,
    [CLIENT]: CLIENT_LEVEL,
    [USER]: USER_LEVEL,
    [OWNER]: OWNER_LEVEL,
};

/**
 * Extract the role the given user has for the client. This is useful
 * should you need to display the users role.
 *
 * @param string clientId the client to look for the role on
 * @param object user the current user (from `useCurrentUser`)
 */
export function roleFor(clientId, { clientMap }) {
    return clientMap[clientId]?.role || defaultRole;
}

/**
 * Check to see if the user is granted the the given role for a client.
 *
 *      import { clientRoles } from '@alli/frontend-common';
 *
 *      // in a component somewhere
 *      const currentUser = useCurrentUser();
 *      if (clientRoles.isGranted(clientRoles.OWNER, currentUser)) {
 *          // ...
 *      }
 *
 * NOTE: this only checks the client permissions, it's up to applications to
 * check admin permissions if desired
 *
 * @param string clientId the client to check permissions on
 * @param string wantedRole one of the role constants above
 * @param object user The current user (from `useCurrentUser`)
 * @return bool True if the user is at or above the role level
 */
export function isGranted(clientId, wantedRole, user) {
    const wantedLevel = roleToLevel[wantedRole];
    if (!wantedLevel) {
        return false; // invalid wanted role
    }

    const currentRole = roleFor(clientId, user);
    const currentLevel = roleToLevel[currentRole] || -1;

    return currentLevel >= wantedLevel;
}
